import React, { useEffect, useState } from "react";
import "./GroupLoansListMembersWithLoans.scss";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography, CircularProgress } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansMemberBalances from "../GroupLoansMemberBalances/GroupLoansMemberBalances";
import CloseIcon from "@mui/icons-material/Close";
import GroupLoansListLoans from "../GroupLoansListLoans/GroupLoansListLoans";
import GroupLoansListPayments from "../GroupLoansListPayments/GroupLoansListPayments";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansListMembersWithLoans = ({ selectedLoan, setSelectedView, selectedView }) => {
    const [membersArray, setMembersArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [membersListView, setMembersListView] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    const [selectedMemberName, setSelectedMemberName] = useState(false);

    useEffect(()=>{
        console.log("GroupLoansListMembersWithLoans-------",selectedLoan)
        getListOfMembers();
    },[]);

    const columns = [
        {
            label: 'Group ID',
            getValue: (row) => row?.loangroupmemberloan?.groupid ?? ''
        },
        {
            label: 'Member Name',
            getValue: (row) => `${row?.u?.firstName} ${row?.u?.lastName}`  ?? ''
        },
        {
            label: 'Request Date',
            getValue: (row) => row?.loangroupmemberloan?.requestdate ?? ''
        },
        {
            label: 'Request Amount',
            getValue: (row) => row?.loangroupmemberloan?.requestamount ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Loan Request Id',
            getValue: (row) => row?.loangroupmemberloan?.loanrequestid ?? ''
        }
    ];

    const getListOfMembers = async() => {
        try {
            const response = await commonRunQuery(294, selectedLoan?.loangroups?.groupid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setMembersArray(groupsArray);
              console.log("getListOfMembers_response==========",groupsArray);
            } else {
                setMembersArray([]);
            }
        } catch (error) {
            console.log("getListOfMembers_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedMember(loan);
        setSelectedMemberName(`${loan?.u?.firstName} ${loan?.u?.lastName}`)
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            {
                membersListView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        List of Members With Loans
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setSelectedView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {loading ? (
                    <Box
                        sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {
                            membersListView == null && <Box className="mt-4">
                                <GroupLoansTable
                                    data={membersArray} 
                                    columns={columns} 
                                    title="List of Members" 
                                    formatRow={(row) => [
                                        row.id,
                                        row.record?.BorrowerName,
                                        row.name,
                                        row.balance,
                                        row.record?.DaysPastDue,
                                        row.record?.AmountDue
                                    ]} 
                                    viewMenu={true}
                                    handleMenuOpen={handleMenuOpen}
                                    downloads={false}
                                    // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                                />
                            </Box>
                        }
                    </>
                )
            }


            { membersListView == "listLoans" && <GroupLoansListLoans selectedMember={selectedMember} setMembersListView={setMembersListView} selectedMemberName={selectedMemberName} /> }
            { membersListView == "listPayments" && <GroupLoansListPayments selectedMember={selectedMember} setMembersListView={setMembersListView} selectedMemberName={selectedMemberName} /> }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        setMembersListView('listLoans');
                        handleMenuClose();
                    }}
                >
                    List Loans
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setMembersListView('listPayments');
                        handleMenuClose();
                    }}
                >
                    List Payments
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="70vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedMember && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                            { label: "User ID", value: selectedMember?.u?.user_id || "N/A" },
                                            { label: "First Name", value: selectedMember?.u?.firstName || "-" },
                                            { label: "Last Name", value: selectedMember?.u?.lastName || "-" },
                                            { label: "Loan Request ID", value: selectedMember?.loangroupmemberloan?.loanrequestid || "N/A" },
                                            { label: "Requested By", value: selectedMember?.loangroupmemberloan?.requestedby || "N/A" },
                                            { label: "Currency Code", value: selectedMember?.loangroupmemberloan?.currcode || "N/A" },
                                            { label: "Loan Type", value: selectedMember?.loangroupmemberloan?.loantype || "N/A" },
                                            { label: "External Ref No", value: selectedMember?.loangroupmemberloan?.externalrefno || "N/A" },
                                            { label: "Comments", value: selectedMember?.loangroupmemberloan?.comments || "N/A" }
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                            { label: "Request Date", value: selectedMember?.loangroupmemberloan?.requestdate || "N/A" },
                                            { label: "Request Amount", value: selectedMember?.loangroupmemberloan?.requestamount ? Number(selectedMember?.loangroupmemberloan?.requestamount).toLocaleString() : "N/A" },
                                            { label: "Current Limit", value: selectedMember?.loangroupmemberloan?.currentlimit ? Number(selectedMember?.loangroupmemberloan?.currentlimit).toLocaleString() : "N/A" },
                                            { label: "Current Outstanding Loan", value: selectedMember?.loangroupmemberloan?.currentoutstandingloan ? Number(selectedMember?.loangroupmemberloan?.currentoutstandingloan).toLocaleString() : "N/A" },
                                            { label: "Issued", value: selectedMember?.loangroupmemberloan?.issued === "1" ? "Yes" : "No" },
                                            { label: "Amount for Fee Calculation", value: selectedMember?.loangroupmemberloan?.amountforfeecalculation ? Number(selectedMember?.loangroupmemberloan?.amountforfeecalculation).toLocaleString() : "N/A" },
                                            { label: "Last Execution Time", value: selectedMember?.loangroupmemberloan?.lastexecutiontime || "N/A" }
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value}</Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="md"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Member Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedMember && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "User ID", value: selectedMember?.u?.user_id || "N/A" },
                                                { label: "First Name", value: selectedMember?.u?.firstName || "-" },
                                                { label: "Last Name", value: selectedMember?.u?.lastName || "-" },
                                                { label: "Loan Request ID", value: selectedMember?.loangroupmemberloan?.loanrequestid || "N/A" },
                                                { label: "Requested By", value: selectedMember?.loangroupmemberloan?.requestedby || "N/A" },
                                                { label: "Currency Code", value: selectedMember?.loangroupmemberloan?.currcode || "N/A" },
                                                { label: "Loan Type", value: selectedMember?.loangroupmemberloan?.loantype || "N/A" },
                                                { label: "External Ref No", value: selectedMember?.loangroupmemberloan?.externalrefno || "N/A" },
                                                { label: "Comments", value: selectedMember?.loangroupmemberloan?.comments || "N/A" }
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Request Date", value: selectedMember?.loangroupmemberloan?.requestdate || "N/A" },
                                                { label: "Request Amount", value: selectedMember?.loangroupmemberloan?.requestamount ? Number(selectedMember?.loangroupmemberloan?.requestamount).toLocaleString() : "N/A" },
                                                { label: "Current Limit", value: selectedMember?.loangroupmemberloan?.currentlimit ? Number(selectedMember?.loangroupmemberloan?.currentlimit).toLocaleString() : "N/A" },
                                                { label: "Current Outstanding Loan", value: selectedMember?.loangroupmemberloan?.currentoutstandingloan ? Number(selectedMember?.loangroupmemberloan?.currentoutstandingloan).toLocaleString() : "N/A" },
                                                { label: "Issued", value: selectedMember?.loangroupmemberloan?.issued === "1" ? "Yes" : "No" },
                                                { label: "Amount for Fee Calculation", value: selectedMember?.loangroupmemberloan?.amountforfeecalculation ? Number(selectedMember?.loangroupmemberloan?.amountforfeecalculation).toLocaleString() : "N/A" },
                                                { label: "Last Execution Time", value: selectedMember?.loangroupmemberloan?.lastexecutiontime || "N/A" }
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
            </Dialog> */}
        </Box>
    )
}

export default GroupLoansListMembersWithLoans;
